export default __webpack_public_path__ + "static/media/bluespacedestactive3.d6398d5f.png";